<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card" v-if="!lodaing">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="repeater_wrapper mt-6 row">
              <div class="col-lg-10">
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(feature, index) in data"
                    :key="index"
                    class="col-lg-12"
                  >
                    <v-expansion-panel-header>
                      <h5>الميزة - {{ index + 1 }}</h5>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="row">
                        <!-- ********** Row Data ********** -->
                        <div class="upload_input_wrapper me-auto col-7">
                          <template v-if="feature.icon">
                            <uplode-image
                              :data_src="feature.icon"
                              @inputChanged="uplodeFeaturesImg($event, index)"
                              placeHolder="أرفق icon"
                            ></uplode-image>
                          </template>
                          <template v-else>
                            <uplode-image
                              @inputChanged="uplodeFeaturesImg($event, index)"
                              placeHolder="أرفق icon"
                            ></uplode-image>
                          </template>
                        </div>

                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @input="helper_checkIfInputIsEmpty"
                              @keypress="isArabic"
                              v-model.trim="feature.title_ar"
                            />
                            <label for="name_input" class="form-label"
                              >العنوان (عربي)</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @input="helper_checkIfInputIsEmpty"
                              @keypress="isEnglish"
                              v-model.trim="feature.title_en"
                            />
                            <label for="name_input" class="form-label"
                              >العنوان (إنجليزي)</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @input="helper_checkIfInputIsEmpty"
                              @keypress="isArabic"
                              v-model.trim="feature.alt_image_ar"
                            />
                            <label for="name_input" class="form-label"
                              >النص البديل (عربي)</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @input="helper_checkIfInputIsEmpty"
                              @keypress="isEnglish"
                              v-model.trim="feature.alt_image_en"
                            />
                            <label for="name_input" class="form-label"
                              >النص البديل (إنجليزي)</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <label for="textarea_1" class="form-label">
                              محتوي الميزة (عربي)</label
                            >
                            <textarea
                              class="form-control"
                              rows="5"
                              @keypress="isArabic"
                              v-model="feature.description_ar"
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-lg-6 py-0">
                          <div class="input_wrapper top_label">
                            <label for="textarea_1" class="form-label"
                              >محتوي الميزة (إنجليزي)</label
                            >
                            <textarea
                              class="form-control"
                              rows="5"
                              @keypress="isEnglish"
                              v-model="feature.description_en"
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-lg-4 py-0 mx-auto">
                          <div class="input_wrapper top_label">
                            <input
                              type="color"
                              class="form-control"
                              v-model.trim="feature.background"
                            />
                            <label for="name_input" class="form-label">
                              لون خلفية الميزة</label
                            >
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <!-- Actions -->
              <div class="col-1 py-0" v-if="data.length > 0 && data.length < 3">
                <span class="append" @click="appendFeature()">
                  <i class="fas fa-plus-circle"></i>
                </span>
              </div>
              <div class="col-1 py-0" v-show="data.length > 3">
                <span class="append" @click="deleteFeature()">
                  <i class="fas fa-minus-circle"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="base-btn" :class="btnIsLoading ? 'disabled' : ''">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.why_us.title"),
          disabled: false,
          href: "/home_page/why_us",
        },
        {
          text: this.$t("breadcrumb.why_us.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: [
        {
          background: null,
          icon: null,
          title_ar: null,
          title_en: null,
          alt_ar: null,
          alt_en: null,
          description_ar: null,
          description_en: null,
        },
        {
          background: null,
          icon: null,
          title_ar: null,
          title_en: null,
          alt_ar: null,
          alt_en: null,
          description_ar: null,
          description_en: null,
        },
        {
          background: null,
          icon: null,
          title_ar: null,
          title_en: null,
          alt_ar: null,
          alt_en: null,
          description_ar: null,
          description_en: null,
        },
      ],
    };
  },

  methods: {
    // Uplode Image
    uplodeFeaturesImg(obj, index) {
      this.data[index].icon = obj;
    },
    appendFeature() {
      this.data.push({
        background: null,
        icon: null,
        title_ar: null,
        title_en: null,
        alt_image_ar: null,
        alt_image_en: null,
        description_ar: null,
        description_en: null,
      });
    },
    deleteFeature() {
      // this.data.splice(-1)
      if (this.data[this.data.length - 1].id) {
        // this.data.intro.features.splice(-1);
        this.axios({
          method: "DELETE",
          url: `feature/${this.data[this.data.length - 1].id}`,
        })
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
            this.data.splice(-1);
          })
          .catch((err) => {
            // this.dialogDelete = false
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.splice(-1);
      }
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      let validate = false;
      if (validate) return;
      this.data.map((feature, index) => {
        if (validate) return;
        if (!feature.title_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل عنوان الميزة رقم ${index + 1}  (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          validate = true;
          return;
        } else if (!feature.title_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل عنوان الميزة رقم ${index + 1}  (انجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          validate = true;
          return;
        } else if (!feature.description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل محتوي الميزة رقم ${index + 1}  (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          validate = true;
          return;
        } else if (!feature.description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `أدخل محتوي الميزة رقم ${index + 1}  (انجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          validate = true;
          return;
        } else if (!feature.icon) {
          this.$iziToast.error({
            timeout: 2000,
            message: `اضف icon للميزة رقم ${index + 1}`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          validate = true;
          return;
        }
      });
      this.submitData();
      return;
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      this.data.forEach((feature, index) => {
        submit_data.append(`features[${index}][ar][title]`, feature.title_ar);
        submit_data.append(`features[${index}][en][title]`, feature.title_en);
        submit_data.append(
          `features[${index}][ar][alt_image]`,
          feature.alt_image_ar ?? ""
        );
        submit_data.append(
          `features[${index}][en][alt_image]`,
          feature.alt_image_en ?? ""
        );
        submit_data.append(
          `features[${index}][ar][description]`,
          feature.description_ar
        );
        submit_data.append(
          `features[${index}][en][description]`,
          feature.description_en
        );
        // submit_data.append(`features[${index}][background]`, '#fff' );
        if (feature.background) {
          submit_data.append(
            `features[${index}][background]`,
            feature.background
          );
        }
        if (feature.id) {
          submit_data.append(`features[${index}][id]`, feature.id);
        }
        if (feature.icon.img_file) {
          submit_data.append(`features[${index}][icon]`, feature.icon.img_file);
        }
      });
      this.axios({
        method: "POST",
        url: "home/why_us/features",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/home_page/why_us/show" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // Set Rows
    setRows() {
      this.lodaing = true;
      this.axios({
        method: "GET",
        url: "home/why_us/features",
      })
        .then((res) => {
          // if(res.data.data.length == 3){
          //   this.data= res.data.data
          // }
          // else if(res.data.data.length < 3){
          //     this.data= res.data.data
          //     for (let i = res.data.data.length  ; i < 3; i++) {
          //       this.data.push({
          //         background: null,
          //         icon: null,
          //         title_ar: null,
          //         title_en: null,
          //         description_ar: null,
          //         description_en: null,
          //       })
          //     }
          // }
          this.data = res.data.data;
          this.lodaing = false;
        })
        .catch(() => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  mounted() {
    // Set Rows
    this.setRows();
  },
};
</script>
